'use client';

import { CustomTooltip } from '@/app/components/shared/CustomTooltip';
import type { CollectionTag } from '@/app/types';
import { cn } from '@/app/utils';

interface CollectionFilterProps {
  collections: CollectionTag[];
  setActiveCollection: (collection: CollectionTag) => void;
}

/**
 * 合集筛选器组件
 * @description 横向滚动的合集列表，每个占父元素的1/4，间距8px
 */
export const CollectionFilter = ({ collections, setActiveCollection }: CollectionFilterProps) => {
  const handleCollectionClick = (collection: CollectionTag) => {
    setActiveCollection(collection);
  };

  if (!collections || collections.length === 0) {
    return null;
  }

  return (
    <div className="w-full">
      <div className="hide-scrollbar flex w-full gap-2 overflow-x-auto">
        {collections.map((collection) => (
          <div
            key={collection.code}
            onClick={() => handleCollectionClick(collection)}
            className={cn(
              'relative box-border flex aspect-[214/92] flex-shrink-0 cursor-pointer items-center justify-center overflow-hidden rounded-16 bg-center bg-cover px-4 font-semibold text-xl leading-[1.4]',
              'shadow-[inset_0_0_0_1px_rgba(255,255,255,0.12)]',
            )}
            style={{
              backgroundImage: `url(${collection.extra?.cover_uri || ''})`,
              width: 'calc(25% - 6px)',
            }}
          >
            {/* 黑色蒙层 */}
            <div className="absolute inset-0 bg-system-black48" />
            {/* 文字内容 */}
            <div className="relative z-10">
              <CustomTooltip content={collection.display_name} maxLines={1} showOnlyOnOverflow={true}>
                {collection.display_name}
              </CustomTooltip>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
